export type TDistanceModelType = 'exponential' | 'inverse' | 'linear';
